<fieldset class="ba-input-group ba-block mb-3" id="fs-{{name}}">
  @if (legend) {
    <legend id="radio-legend-{{name}}">
      {{ legend }}
      @if (required) {
        *
      }
    </legend>
  }

  <div
    class="ba-radio-group"
    role="radiogroup"
    [attr.aria-labelledby]="legend ? 'radio-legend-' + name : null"
    [attr.aria-required]="required"
    >
    @for (option of options; track option) {
      <div class="form-check" [ngClass]="{ 'ba-image': !!option.image }">
        <input
          type="radio"
          [id]="'radio-' + option.value"
          [name]="name"
          [value]="option.value"
          [checked]="value === option.value"
          (change)="onSelectionChange(option.value)"
          [attr.aria-label]="option.label"
          [attr.aria-describedby]="'extra-text-' + option.value"
          />
        <label [for]="'radio-' + option.value">
          {{ option.label }}
          @if (option.image) {
            <img [src]="option.image" [alt]="'Logo ' + option.label">
          }
        </label>
        <ul [id]="'extra-text-' + option.value" class="form-text">
          @for (info of (option.infos ?? []); track info) {
            <li>{{ info }}</li>
          }
        </ul>
      </div>
    }
  </div>
</fieldset>